import { Components, Theme } from '@mui/material'

// MUI caps the tooltip at 300px and wraps beyond it. `variant="fit-content"` lets the bubble grow
// to fit its content up to a wider ceiling, past which it still wraps so a long label can't run
// off-screen. Driven off ownerState (Tooltip spreads its props there) rather than the theme
// `variants` array, which only reaches the popper root slot, not the bubble.
declare module '@mui/material/Tooltip' {
  interface TooltipProps {
    variant?: 'fit-content'
  }
}

const FIT_CONTENT_MAX_WIDTH = 400

export const MuiTooltip: Components<Omit<Theme, 'components'>>['MuiTooltip'] = {
  defaultProps: {
    arrow: true,
  },
  styleOverrides: {
    tooltip: ({ theme, ownerState }) => ({
      backgroundColor: theme.palette.bg.inverted,
      color: theme.palette.text.inverted,
      borderRadius: theme.shape['radius-xs'],
      padding: theme.spacing(0.5, 1.5),
      ...theme.typography['small-regular'],
      ...(ownerState.variant === 'fit-content' && { maxWidth: FIT_CONTENT_MAX_WIDTH }),
    }),
    arrow: ({ theme }) => ({
      color: theme.palette.bg.inverted,
    }),
    popper: ({ theme }) => ({
      '&[data-popper-placement*="bottom"] .MuiTooltip-tooltip.MuiTooltip-tooltipPlacementBottom': {
        marginTop: theme.spacing(3),
      },
    }),
  },
}
